import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DashboardService } from '../dashboard';
import { ErrorHandlerService } from '../services';
import { Observable } from 'rxjs';
var ViewProfileAuthGuard = /** @class */ (function () {
    function ViewProfileAuthGuard(dashboardService, errorHandlerService) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.userId = null;
        this.isProfileAlive = true;
        this.userDeletedError = {};
    }
    ViewProfileAuthGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        console.log("Entering the canActivate method of the ViewProfileAuthGuard");
        this.isProfileAlive = true;
        this.userId = route.queryParams['user'];
        if (this.userId == undefined || this.userId == null) {
            return Observable.of(this.isProfileAlive);
        }
        console.log("this.userId =" + this.userId);
        return this.dashboardService.userAccountStatus(this.userId).map(function (data) {
            _this.isProfileAlive = (data.accountDeleted === 'T' || (data.accountActive !== null && data.accountActive !== 'T') ? false : true);
            console.log("Inside the call to get User Data this.isProfileAlive =" + _this.isProfileAlive);
            if (!_this.isProfileAlive) {
                console.log("The Profile is not active, going to throw error");
                _this.userDeletedError = { "userDeleted": !_this.isProfileAlive };
                _this.errorHandlerService.throwError(_this.userDeletedError);
            }
            console.log("Just Before Returning this.isProfileAlive =" + _this.isProfileAlive);
            return _this.isProfileAlive;
        }, function (error) {
            console.log("Error occurred");
            return _this.isProfileAlive;
        });
    };
    return ViewProfileAuthGuard;
}());
export { ViewProfileAuthGuard };
//# sourceMappingURL=view.profile.auth.guard.js.map